import styled from 'styled-components';

export const FieldWrap = styled.div`
  margin-bottom: 1.7rem;
`;

export default FieldWrap;
